import React from 'react'
import Head from 'next/head'
import MobileDetect from 'mobile-detect'
import MobileFeedBack from '@mobilePages/MobileFeedBack/MobileFeedBack'
import Feedback from '../../src/components/Pages/Contact/Feedback/Feedback'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

export default function FeedbackIndex(props) {
    return (
        <React.Fragment>
            <Head>
                <title>Обратная связь - сеть аптек ЗДОРОВ.ру</title>
            </Head>
            <GoogleReCaptchaProvider reCaptchaKey="6LdbOf8UAAAAAFAj22u14hzBaL-7yxQ7EDRmlLu3">
                {/* eslint-disable-next-line react/prop-types */}
                {props.mobile ? <MobileFeedBack /> : <Feedback />}
            </GoogleReCaptchaProvider>
        </React.Fragment>
    )
}

export const getServerSideProps = async (ctx) => {
    const md = new MobileDetect(ctx.req.headers['user-agent'])
    return { props: { mobile: md.mobile() } }
}
